import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const WFAWindowMock: FC = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3">
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faArrowsRotate} className="text-sm text-cyan-400" />
            <h3 className="text-sm font-medium text-gray-300 uppercase tracking-wide">Walk-Forward Analysis</h3>
          </div>
          <span className="text-[10px] text-gray-500">5 windows &middot; Anchored</span>
        </div>

        {/* Window timeline */}
        <div className="space-y-2 mb-4">
          {[
            { win: 1, is: '2021-01 to 2022-06', oos: '2022-06 to 2022-12', oosReturn: '+8.2%', sharpe: '1.14', pass: true },
            { win: 2, is: '2021-01 to 2022-12', oos: '2022-12 to 2023-06', oosReturn: '+5.7%', sharpe: '0.98', pass: true },
            { win: 3, is: '2021-01 to 2023-06', oos: '2023-06 to 2023-12', oosReturn: '+12.1%', sharpe: '1.41', pass: true },
            { win: 4, is: '2021-01 to 2023-12', oos: '2023-12 to 2024-06', oosReturn: '+3.8%', sharpe: '0.72', pass: false },
            { win: 5, is: '2021-01 to 2024-06', oos: '2024-06 to 2024-12', oosReturn: '+9.4%', sharpe: '1.18', pass: true },
          ].map((w) => (
            <div key={w.win} className="flex items-center gap-3 px-3 py-2 rounded bg-white/[0.02]">
              <span className="text-[10px] text-gray-500 w-6">W{w.win}</span>
              <div className="flex-1 h-3 rounded-sm bg-blue-500/20 relative">
                <span className="absolute inset-0 flex items-center justify-center text-[8px] text-blue-400/70">IS</span>
              </div>
              <div className={`w-20 h-3 rounded-sm ${w.pass ? 'bg-emerald-500/20' : 'bg-rose-500/20'} relative`}>
                <span className={`absolute inset-0 flex items-center justify-center text-[8px] ${w.pass ? 'text-emerald-400/70' : 'text-rose-400/70'}`}>OOS</span>
              </div>
              <span className={`text-[10px] w-12 text-right ${w.pass ? 'text-emerald-400' : 'text-rose-400'}`}>{w.oosReturn}</span>
              <span className="text-[10px] text-gray-400 w-10 text-right">{w.sharpe}</span>
              <FontAwesomeIcon
                icon={faCheckCircle}
                className={`text-[10px] ${w.pass ? 'text-emerald-400' : 'text-rose-400'}`}
              />
            </div>
          ))}
        </div>

        {/* WFA Summary */}
        <div className="grid grid-cols-4 gap-3 px-3 py-2 rounded bg-white/[0.03] border border-white/[0.04]">
          {[
            { label: 'WFE', value: '72%', color: 'text-emerald-400' },
            { label: 'OOS Sharpe', value: '1.09', color: 'text-white' },
            { label: 'Pass Rate', value: '4/5', color: 'text-emerald-400' },
            { label: 'Verdict', value: 'Pass', color: 'text-emerald-400' },
          ].map((m) => (
            <div key={m.label} className="text-center">
              <div className="text-[9px] text-gray-500 uppercase tracking-wider">{m.label}</div>
              <div className={`text-sm font-semibold ${m.color}`}>{m.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default WFAWindowMock;
